"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputConsumer = _interopRequireDefault(require("../InputConsumer"));

var _GroupSt = require("./Group.st.css");

var Group = function Group(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_InputConsumer["default"], {
    consumerCompName: Group.displayName
  }, function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _GroupSt.classes.root
    }, children);
  });
};

Group.displayName = 'Input.Group';
Group.propTypes = {
  children: _propTypes["default"].node
};
var _default = Group;
exports["default"] = _default;